<template>
  <div class="page-content">
    <div class="daily-closing">
      <h1 class="page-title">{{ $locale("sideMenu.operations.dailyClosing") }}</h1>

      <!-- Search Area -->
      <el-row class="search-area" :gutter="10">
        <el-col :span="15">
          <DatePickerGroup
            v-model="filter"
            v-bind:showWeekly="true"
            :startPickerOptions="datePickerOptions"
            :endPickerOptions="datePickerOptions"
          />
          <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col class="ta-r" :span="9">
          <el-button
            :class="this.adminType === 'brand' ? 'egl-btn-gray' : 'egl-btn-yellow'"
            :disabled="this.adminType === 'brand'"
            @click="showDialogAction({dialogName: 'step1', action: 'create'})"
          >
            {{ $locale("dailyClosing.createDailyClosing") }}
          </el-button>
          <el-button
            :class="notApprove ? 'egl-btn-gray' : 'egl-btn-yellow'"
            :disabled="notApprove"
            @click="approve_fn"
          >
            {{ $locale("global.approve") }}
          </el-button>
        </el-col>
      </el-row>

      <el-table
        stripe
        class="egl-table list-table result-table"
        :data="dailyClosingListData"
        @sort-change="sort_fn"
      >
        <el-table-column min-width="50" align="center" :label="$locale('global.change')">
          <template slot-scope="scope">
            <i class="el-icon-circle-check change" v-if="!scope.row.approve"></i>
          </template>
        </el-table-column>
        <template v-for="th in thead">
          <el-table-column
            :min-width="th.width"
            :label="th.label"
            :prop="th.prop"
            :key="th.prop"
            :sortable="th.sort"
            :align="th.align || 'center'"
          >
            <template slot-scope="scope">
              <template v-if="th.prop === 'dayCloseDate'">
                {{ $moment(scope.row[th.prop]).format("YYYY/MM/DD") }}
              </template>
              <template v-else-if="th.prop === 'dueDate'">
                {{ $moment(scope.row[th.prop]).format("YYYY/MM/DD HH:mm:ss") }}
              </template>
              <template v-else>{{ scope.row[th.prop] }}</template>
            </template>
          </el-table-column>
        </template>
        <el-table-column align="center" :label="$locale('global.control')" min-width="150">
          <template slot-scope="scope">
            <div class="handle">
              <a @click="showDialogAction({dialogName: 'step1', dcId: scope.row.id, action: 'detail'})">{{ $locale("global.detail") }}</a>
              <template v-if="scope.row.type !== 'cms' && scope.row.type !== 'online'">
                <el-divider direction="vertical"></el-divider>
                <a @click="showDialogAction({dialogName: 'step1', dcId: scope.row.id, action: 'edit'})">{{ $locale("global.edit") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="delete_fn(scope.$index)">{{ $locale("global.delete") }}</a>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <CommPagination
        :total="filter.pageCount"
        :curPage="filter.currentPage"
        @current-change="choosePage"
      />

      <BasicInfo
        :visible="dialogVisible.step1"
        :visibleC="dialogVisible.step1"
        :actionType="dialogAction"
        :actionTypeC="dialogAction"
        :shiftList="shiftList"
        :otherRevList="otherRevList"
        :otherGoodsList="otherGoodsList"
        :sellList="sellList"
        :paymentList="paymentList"
        :cinemaList="cinemaList"
        :clientList="clientList"
        :detailData.sync="dailyClosingDetailData"
        @closeDialogFn="closeDialogAction"
        @getDailyClosingShiftList="getDailyClosingShiftList"
      ></BasicInfo>

      <Cash
        :visible="dialogVisible.step2"
        :actionType="dialogAction"
        :depositList="depositList"
        :detailData.sync="dailyClosingDetailData"
        @closeDialogFn="closeDialogAction"
      ></Cash>

      <AccountsReceivable
        :visible="dialogVisible.step3"
        :actionType="dialogAction"
        :actionTypeC="dialogAction"
        :clientList="clientList"
        :otherRevList="otherRevList"
        :receivableList="receivableList"
        :detailData.sync="dailyClosingDetailData"
        :lastLaunchDialog="lastLaunchDialog"
        @closeDialogFn="closeDialogAction"
      ></AccountsReceivable>

      <TheaterAdvanceTicket
        :visible="dialogVisible.step4"
        :actionType="dialogAction"
        :detailData.sync="dailyClosingDetailData"
        @closeDialogFn="closeDialogAction"
        @searchFn="search_fn"
      ></TheaterAdvanceTicket>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import tranfResData from "@/utils/tranfResData";
import CommPagination from "@/components/common/CommPagination";
// import DatePickerGroup from "@/components/DatePickerGroup";
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup";
import CountDownAlert from "@/utils/countDownAlert";
import { requestAll } from "@/helpers/service/axiosPlugin";

import {
  getCinemaList,
  getDeposit,
  deleteDailyClosing,
  approveDailyClosing,
  getDailyClosingList,
  getDailyClosingDetail,
  getDailyClosingShiftList as getDailyClosingShiftListService,
  getOtherRevenueList,
  getOtherGoods,
  getDailyClosingSellList,
  getDailyClosingPayment,
  getDailyClosingReceivable,
} from "@/helpers/service/api/dailyClosingNew";
import { getClientListService } from "@/helpers/service/api/common";
import {
  createDailyClosingColumn,
  createTypeList,
} from "@/assets/js/dailyClosingNew";
import {
  BasicInfo,
  Cash,
  AccountsReceivable,
  TheaterAdvanceTicket,
} from "@/components/Operations/DailyClosing";
import "@/assets/style/dailyClosing.less";

export default {
  name: "DailyClosing",
  provide() {
    return {
      clientList: () => this.provideClientList
    };
  },
  components: {
    CommPagination,
    DatePickerGroup,
    BasicInfo,
    Cash,
    AccountsReceivable,
    TheaterAdvanceTicket,
  },
  data() {
    return {
      filter: {
        startDate: this.$moment().valueOf(),
        endDate: this.$moment().valueOf(),
        currentPage: 0,
        pageCount: 0,
      },
      dialogAction: null, // ["create", "edit", "detail"]
      dialogVisible: {
        step1: false ,
        step2: false ,
        step3: false ,
        step4: false
      },
      lastLaunchDialog: null,
      shiftList: [],
      clientList: [],
      cinemaList: [],
      otherRevList: [],
      otherGoodsList: [],
      sellList: [],
      paymentList: [],
      depositList: [],
      receivableList: {},
      dailyClosingListData: [],
      dailyClosingDetailData: this.initData(),
      thead: createDailyClosingColumn(),
      typeList: createTypeList(),
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
      currentDayClosingId: null,
      // showDialog: {
      //   createRecord: false,
      //   cashTable: false,
      //   accountsReceivableTable: false,
      //   theaterAdvanceTicketTable: false
      // },
      // dialogMsg: {},
      // paymentRegistrationMsg: {},
      // paymentRegistrationAction: "create",
      // accountPayableMsg: {},
      // accountPayableArr: [],
      // isOneTimePayment: false,
      // paymentItem: {},
      // dialogData: {
      //   createRecord: {},
      //   cashTable: {},
      //   accountsReceivableTable: {},
      //   theaterAdvanceTicketTable: {}
      // },
      provideClientList: [],
    };
  },
  computed: {
    ...mapState("app", {
      token: state => state.token,
      cinemaId: state => state.cinemaId,
      brandId: state => state.brandId,
      adminType: state => state.adminType,
    }),
    notApprove() {
      if (this.dailyClosingListData.length === 0) {
        return true;
      }

      const _hasNonApprove = this.dailyClosingListData.find(_list => _list.approve === false);
      return !_hasNonApprove;
    },
    theadFilter() {
      let _resultObj = {
        type: [],
      };

      this.typeList.forEach(typeObj => {
        _resultObj.type.push(typeObj.value);
      });

      return _resultObj;
    },
  },
  async created() {
    await getClientListService({
      page: 0,
      pageSize: 20,
      field: ["id", "name"]
    }).then(res => {
      this.provideClientList = res.data.data;
    });
    await requestAll([
      // getClientListService({ page: 0, pageSize: 9999, field: ["id", "name", "clientCode", "groupName", "aliasName"] }),
      getCinemaList(),
      this.search_fn(),
    ]).then(res => {
      // const _clientList = res[0].data ? res[0].data.data || [] : [];
      // const _cinemaList = res[1].data ? res[0].data.data || [] : [];
      const _cinemaList = res[0].data ? res[0].data.data || [] : [];
      // this.clientList = tranfResData(_clientList);
      this.cinemaList = tranfResData(_cinemaList);
    });
  },
  methods: {
    initData() {
      return {
        id: "",
        dayCloseDate: this.$moment().valueOf(),
        weather: 0,
        accountsPayment: [],
        accountsRecovery: [],
        otherCashPayment: [],
        otherCashRecovery: [],
        shifts: [],
        amountCalculationInfo: {}, //step2
        accountPayableInCashs: {}, //step3
        theaterTicket: {},
        note: '',
      };
    },
    async showDialogAction({
      dialogName = "step1",
      dcId, //dayCloseId
      action,
      isBack = false,
    }) {
      const _stateHandler = () => {
        if (dialogName === "step1") {
          this.shiftList = [];
          this.getDailyClosingShiftList();
          this.getSellAndPaymentList();
        }

        if (action) { this.dialogAction = action; }

        if (action === "detail") {
          const { shifts: sIds } = this.dailyClosingDetailData;
          const _shiftList = this.shiftList.filter(_list => sIds.includes(_list.id));
          this.shiftList = _shiftList;
        }

        Object.keys(this.dialogVisible).forEach(key => {
          if (key === dialogName) {
            this.dialogVisible[key] = true;
          } else {
            this.dialogVisible[key] = false;
          }
        });
      };
      const { dayCloseDate } = this.dailyClosingDetailData;
      const _requestDate = this.$moment(dayCloseDate).format("YYYY-MM-DD");

      if (dcId) { this.currentDayClosingId = dcId; }

      if (dialogName === "step1" && !isBack) {
        if (
          this.otherRevList.length === 0
          || this.otherGoodsList.length === 0
          || this.paymentList.length === 0
          || this.sellList.length === 0
        ) {
          await requestAll([
            getOtherRevenueList(this.cinemaId),
            getOtherGoods(this.cinemaId),
          ]).then(res => {
            const [
              otherRevList,
              otherGoodsList,
            ] = res;

            this.otherRevList = otherRevList.data.data ? otherRevList.data.data : [];
            this.otherGoodsList = otherGoodsList.data.data ? otherGoodsList.data.data : [];
          });
        }
      } else if (this.depositList.length === 0 && dialogName === "step2" && !isBack) {
        await getDeposit().then(res => {
          this.depositList = res.data ? res.data : [];
        });
      } else if (Object.keys(this.receivableList).length === 0 && dialogName === "step3" && !isBack) {
        await getDailyClosingReceivable({
          cinemaId : this.cinemaId,
          date: _requestDate,
        }).then(res => {
          this.receivableList = res.data ? res.data : {};

          const _targetObj = this.dailyClosingDetailData.accountPayableInCashs.cashDetails;
          if (_targetObj) {
            Object.keys(_targetObj).forEach(_key => {
              _targetObj[_key].forEach(_list => {
                const __obj = this.receivableList[_key].find(_v => _v.id === _list.settlementId) || {};
                _list.price = __obj.price || 0;
              });
            });
          }
        });
      }

      if (dcId && !isBack) {
        await getDailyClosingDetail(dcId).then(res => {
          const _resData = res.data ? tranfResData(res.data) : {};
          this.dailyClosingDetailData = _resData;

          _stateHandler();
        });
      } else {
        _stateHandler();
      }
    },
    closeDialogAction({ name, prevStep = false, nextStep = false }) {
      if (this.dialogVisible[name]) {
        this.lastLaunchDialog = name;

        if (!prevStep && !nextStep) {
          this.dialogVisible[name] = false;

          const _dialogStatus = !Object.values(this.dialogVisible).includes(true);
          if (_dialogStatus) {
            this.dailyClosingDetailData = this.initData();
            this.currentDayClosingId = null;
          }
        } else if (prevStep && name !== "step1") {
          const _prevStepIdx = Number(name.substr(4)) - 1;
          this.showDialogAction({ dialogName: "step" + _prevStepIdx, isBack: prevStep });
        } else if (nextStep && name !== "step4") {
          const _nextStepIdx = Number(name.substr(4)) + 1;
          this.showDialogAction({ dialogName: "step" + _nextStepIdx, isBack: prevStep });
        }
      }
    },
    approve_fn() {
      approveDailyClosing({ cinemaId: this.cinemaId }).then(res => {
        if (res.success) {
          CountDownAlert({ content: this.$locale("global.operationSuccessful"), callback: this.search_fn });
        }
      });
    },
    getDate_fn(obj = {}) {
      const { startDate, endDate } = obj;
      this.filter = {
        ...this.filter,
        startDate,
        endDate,
      };
    },
    async search_fn() {
      const params = {
        cinemaId: this.cinemaId,
        page: this.filter.currentPage,
        startDate : this.$moment(this.filter.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.filter.endDate).format("YYYY-MM-DD")
      };

      await getDailyClosingList(params).then(res => {
        if (res.data) {
          const { data, count } = res.data;
          this.dailyClosingListData = data ? data : [];
          this.filter.pageCount = count ? count : 0;
        } else {
          this.dailyClosingListData = [];
          this.filter.pageCount = 0;
        }
      });
    },
    async getDailyClosingShiftList() {
      const { currentDayClosingId, dailyClosingDetailData: { dayCloseDate } } = this;
      const _requestDate = this.$moment(dayCloseDate).format("YYYY-MM-DD");

      await getDailyClosingShiftListService({
        cinemaId: this.cinemaId,
        date: _requestDate,
        ...(currentDayClosingId ? { dayCloseId: currentDayClosingId } : {})
      }).then(res => {
        this.shiftList = res.data ? res.data : [];
      });
    },
    async getSellAndPaymentList() {
      const { dailyClosingDetailData: { dayCloseDate } } = this;
      const _requestDate = this.$moment(dayCloseDate).format("YYYY-MM-DD");

      await requestAll([
        getDailyClosingPayment({
          cinemaId: this.cinemaId,
          date: _requestDate,
        }),
        getDailyClosingSellList({
          cinemaId: this.cinemaId,
          date: _requestDate,
        }),
      ]).then(res => {
        const [
          paymentList,
          sellList,
        ] = res;

        this.paymentList = paymentList.data ? paymentList.data : [];
        this.sellList = sellList.data ? sellList.data : [];
      });
    },
    choosePage(_page) {
      this.filter.currentPage = _page - 1;
      this.search_fn();
    },
    //old function
    // closePaymentRegistrationDialog() {
    //   let dialog = { ...this.showDialog };

    //   dialog.paymentRegistration = false;

    //   this.showDialog = dialog;
    //   this.dialogAction = "";
    //   this.paymentRegistrationMsg = {};
    //   this.accountPayableMsg = {};
    //   this.isOneTimePayment = false;
    // },
    sort_fn({ prop, order }) {
      let sort = [ ...this.onSearch.sort ];
      let keyName = "";
      let sortType = "";
      // let sortIndex = -1;
      let val = "";

      if (order == "ascending") {
        sortType = "ASC";
      } else if (order == "descending") {
        sortType = "DESC";
      }

      for (let i = 0; i < this.thead.length; i++) {
        if (prop == this.thead[i].prop) {
          keyName = this.thead[i].apiProp;
          break;
        }
      }

      val = keyName + ":" + sortType;

      // for (let i = 0; i < sort.length; i++) {
      //   let thisKeyName = sort[i].substring(0, sort[i].indexOf(":"));
      //   if (thisKeyName == keyName) {
      //     sortIndex = i;
      //     break;
      //   }
      // }

      // if (sortIndex < 0) {
      //   sort.push(val);
      // } else {
      //   if (sortType == "") {
      //     sort.splice(sortIndex, 1);
      //   } else {
      //     sort[sortIndex] = val;
      //   }
      // }
      if (sortType == "") {
        sort = [];
      } else {
        sort[0] = val;
      }

      this.onSearch = { ...this.onSearch, sort: sort };
      this.search_fn();
    },
    //old function
    delete_fn(index) {
      let { id } = this.dailyClosingListData[index];
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        deleteDailyClosing({ id }).then(res => {
          if (res.success) {
            CountDownAlert({ content: this.$locale("global.deleteSuccessfully"), callback: this.search_fn });
          }
        });
      });
    },
    dateDisableDate(time) {
      return time.getTime() > this.$moment().valueOf();
    },
    //old function, can del
    // showDetail(index, act = "view") {
    //   let dialog = { ...this.showDialog };
    //   let dialogMsg = tranfResData(this.shiftList[index]);
    //   let rowSpanType = dialogMsg.type;
    //   let accountPayableId = dialogMsg.id;
    //   let accountPayableArr = [];

    //   if (rowSpanType == "ELSE_BUY") {
    //     dialog.otherPurchase = true;
    //   }
    //   if (rowSpanType == "BUY") {
    //     dialog.purchase = true;
    //   }
    //   if (rowSpanType == "TICKETING") {
    //     dialog.ticketing = true;
    //   }
    //   if (rowSpanType == "PROXY_BUY") {
    //     dialog.proxy = true;
    //   }

    //   getAccountPayablePaymentList(this.brandId, accountPayableId).then(res => {
    //     accountPayableArr = res.data.data;

    //     this.showDialog = dialog;
    //     this.dialogAction = act;
    //     this.dialogMsg = dialogMsg;
    //     this.accountPayableArr = accountPayableArr;
    //   });
    // },
    // showPaymentRegistration(index, act = "create", listIndex = -1, isOneTimePayment = false) {
    //   const that = this;
    //   let dialog = { ...this.showDialog, paymentRegistration: true };
    //   let accountPayableMsg = {};
    //   let paymentRegistrationAction = act;
    //   let paymentRegistrationMsg = {};

    //   if (index >= 0) {
    //     accountPayableMsg = JSON.parse(JSON.stringify(that.originalData[index]));
    //   } else {
    //     accountPayableMsg = JSON.parse(JSON.stringify(that.dialogMsg));
    //   }

    //   if (paymentRegistrationAction != "create") {
    //     paymentRegistrationMsg = JSON.parse(JSON.stringify(that.accountPayableArr[listIndex]));
    //   }

    //   that.paymentRegistrationAction = paymentRegistrationAction;
    //   that.paymentRegistrationMsg = paymentRegistrationMsg;
    //   that.accountPayableMsg = accountPayableMsg;
    //   that.showDialog = dialog;
    //   that.isOneTimePayment = isOneTimePayment;
    // },
    // refreshPaymentTable() {
    //   let dialog = { ...this.showDialog, paymentRegistration: false };
    //   let accountPayableId = this.dialogMsg.id;
    //   let accountPayableArr = [];

    //   getAccountPayablePaymentList(this.brandId, accountPayableId).then(res => {
    //     accountPayableArr = res.data.data;

    //     this.showDialog = dialog;
    //     this.accountPayableArr = accountPayableArr;
    //   });
    // },
    // forPaymentList(obj) {
    //   this.paymentItem = obj;
    //   this.closePaymentRegistrationDialog();
    // },
  },
};
</script>

<style scoped lang="less">
.daily-closing {
  ::v-deep .el-dialog__body {
    padding: 0 25px;

    h2 {
      margin: 0 auto;
      font-weight: normal;
      font-size: 1.5rem;
    }

    .el-row + hr.dotted {
      margin: 0 auto 15px;
    }
  }

  ::v-deep .el-table__row.total-row,
  ::v-deep .el-table__row.total-row td {
    font-weight: bold;
    background: @secondly-yellow;
  }

  ::v-deep .el-table__row.sub-total-row,
  ::v-deep .el-table__row.sub-total-row td {
    background: @secondly-orange;
  }

  ::v-deep .handle.ctrl {
    text-align: right;

    .el-button {
      width: 40px;
      padding: 12px;
    }
  }

  ::v-deep .module-item-tit {
    margin-top: 30px;
  }
}
</style>